import { getFieldNameFromEqlField } from '@modules/common/utils';
import { QuantifyQuery } from '@modules/quantify/store/types';
import { EqlFieldValueType } from 'generated/graphql';
import { FieldNames } from 'v2/core/entities/fields';
import { WhereClause } from 'v2/core/services/queryBuilder/whereClause';

export const getHasMetadataFilterForEqlField = (
  groupBy: QuantifyQuery['groupBy'],
): WhereClause | null => {
  if (!groupBy || groupBy?.valueType === EqlFieldValueType.None) {
    return null;
  }

  const groupByFieldName = getFieldNameFromEqlField(groupBy);

  if (groupByFieldName === FieldNames.Metadata) {
    return {
      filter: {
        hasMetadataFilter: {
          keys: [groupBy.field],
        },
      },
    };
  }

  return null;
};
